<template>
  <div class="dashboard">
    <div class="container mt-5 mb-5">
      <Indicators />
    </div>
  </div>
</template>

<script>
import Indicators from '@/components/dashboard/Indicators.vue'

export default {
  components: {
    Indicators
  }
}
</script>
